export default __webpack_public_path__ + "8773d5464c431c4577c1dcaadc592ba3.woff";